import {putAll, showBeError, showSuccess, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';

import {adminAction, RemoveOtherSubjectRolesForUserAction} from '../action';

const tt = t('admin');

function* execute({payload: {userProfileId, otherSubjectId}}: RemoveOtherSubjectRolesForUserAction): SagaIterator {
    const response = yield* call(
        Api.endUserProfileOtherSubjectRoleBindingForUserProfile,
        {userProfileId, otherSubjectId},
    );

    if (response.isSuccess) {
        yield* put(adminAction.getManagementOtherSubjectsTableData(opt({action: 'refresh'}), opt(otherSubjectId)));
        yield putAll(showSuccess(
            tt('removeRolesForUser'),
            tt('removeRolesForUserSuccess'),
            false,
            'removeRolesForUser',
        ));
    } else {
        yield putAll(showBeError(response, tt('removeRolesForUser')));
    }
}

/** Runs the admin saga that removes other-subject roles from the selected user. */
export function* removeOtherSubjectRolesForUserSaga(): SagaIterator {
    yield takeLatestF('admin/REMOVE_OTHER_SUBJECT_ROLES_FOR_USER', execute);
}
